import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=e97fe1f0&"
import script from "./OrderType.vue?vue&type=script&lang=ts&"
export * from "./OrderType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports